import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 9);
  const col3 = categories.slice(9, 14);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">OB</span>
              </div>
              <span className="font-heading font-semibold text-lg text-foreground-950">
                oopbuyspread.bond
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm mb-4">
              Deine unabhängige Informationsplattform für OOPBuy Spreadsheet in Deutschland.
              Wir helfen dir, die besten Fashion-Funde aus China zu entdecken.
            </p>
            <p className="text-xs text-foreground-500">
              Diese Website ist eine unabhängige Informationsplattform und nicht die offizielle OOPBuy-Website.
            </p>
          </div>

          {/* Category Columns */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Kategorien
            </h4>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Mehr Kategorien
            </h4>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Weitere
            </h4>
            <ul className="space-y-2.5">
              {col3.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 oopbuyspread.bond – Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>Impressum</span>
            <span className="text-foreground-300">|</span>
            <span>Datenschutz</span>
            <span className="text-foreground-300">|</span>
            <span>Disclaimer</span>
          </div>
        </div>
      </div>
    </footer>
  );
}